import axios from 'axios'

import type { Release } from '../types/release.type'

export interface IFetchReleases {
  page: number
  limit: number
}

export type FetchReleaseResponse = {
  releases: Release[]
  page: number
  limit: number
  total: number
  currentRelease: string
}

export const fetchReleasesService = async ({
  limit,
  page,
}: IFetchReleases): Promise<FetchReleaseResponse> => {
  const response = await axios.get(
    'https://api-plataforma.cnesistemas.com.br/api/releases/published',
    {
      params: {
        page,
        limit,
        projectId: '89abe984-d90d-4308-8de6-402c4f72638a',
      },
    },
  )

  return response.data
}
